import { Job, JobFromAPI } from '../types';
import { transformJob } from './api-transforms';
import apiRequest from './apiRequest';

type Payload = {
  wsHttpEndpoint: string;
  wsConnectionID: string;
};

export default async function postWsAndFetchJob(jobID: string, data: Payload) {
  const res = await apiRequest<JobFromAPI>(
    'mogen-orchestration',
    `/jobs/ws/${jobID}`,
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
  );

  return {
    error: res.error,
    data: transformJob(res.data),
  };
}
